import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import LogoSvg from "../../atoms/LogoSvg/LogoSvg";
import QUESTION_MARK from "../../../assets/images/QUESTION-MARK.svg";
import Text from "../../atoms/Text/Text";
import Title from "../../atoms/Title/Title";
import Footer from "../../templates/Footer/Footer";
import Header from "../../templates/Header/Header";
import StyledButton from "../../atoms/StyledButton/StyledButton";
import { config as appConfig } from "../../../config";
import { isAppSource } from "../../../helpers/getSourceFromUrl";

const Unknown = () => {
  const { t } = useTranslation();

  const ReturnToTheApp = () => {
    if (isAppSource()) {
      window.location.href = 'weenect://app/home';
    } else {
      window.location.href = appConfig.REACT_APP_FE_BASE_URL;
    }
  };

  return (
    <Box className="App">
      <Header headerStep={{ context: "new_subscription", step: 4, totalSteps: 3 }}title={t("subscription:UNKNOWN_PAGE.TITLE")} />
      <Box className="Unknown">
        <Box className="content">
            <LogoSvg className="Logos" src={QUESTION_MARK} />
          <Title
            variant="h1"
            children={t("subscription:UNKNOWN_PAGE.TITLE")}
          />
          <Text children={t("subscription:UNKNOWN_PAGE.TEXT")} />
        </Box>
      </Box>
      <Footer headerStep={{ context: "new_subscription", step: 4, totalSteps: 3 }}>
        <StyledButton
          children={t("subscription:UNKNOWN_PAGE.BUTTON")}
          onClick={() => ReturnToTheApp()}
        />
      </Footer>
    </Box>
  );
};

export default Unknown;
